import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-nav-over",
  "use": "icon-nav-over-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-nav-over\">\r\n<path d=\"M80.1,144.3l0-11.1l-69.9-0.1l0,44.4c0,12.3,8.9,22.3,20.1,22.3l140,0.3c11,0,20-9.8,20-22.2l-0.1-44.4l-70.1-0.1l0,11.1\r\n\tL80.1,144.3L80.1,144.3z M179.9,44.5l-40.1-0.1l0-22.1L119.7,0.1L79.8,0l-20,22.2l0,22.2L20,44.4C9,44.2,0,54.2,0,66.5l0.1,33.3\r\n\tC0.1,112,9,122,20.1,122.1l60,0.1l0-22.2L120,100l0,22.2l60,0.1c11,0,20-10,20-22.2L200,66.8C199.9,54.6,190.9,44.6,179.9,44.5\r\n\tL179.9,44.5z M119.9,44.4L80,44.4l0-22.1l39.9,0.1L119.9,44.4z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/nav/nav-over.svg
// module id = wTTj
// module chunks = 13